
import SettingsLayout from "components/shared/layouts/SettingsLayout"
import SelectReportDate from "./SelectReportDate"
import { useUI } from "providers/UIProvider"
import ExcelTable from "./ExcelTable"


const ExtractReportsTemaplate = () => {
  const { T } = useUI()

  return (
    // Keyword - extract_report.title
    <SettingsLayout title={T("extract_report.title")} withCompanyBranches={false}>
      <>
        <SelectReportDate />
        <ExcelTable />
      </>
    </SettingsLayout>
  )
}

export default ExtractReportsTemaplate
